module.exports = __webpack_public_path__ + "static/media/stats_chart.0b7bbaa3.png";